module.exports = "<div class=\"subnav-header\">\n  <v-list>\n    <v-list-tile\n      v-for=\"(menu,i) in dtWidget\"\n      :key=\"i\"\n      @click=\"goTo(menu.key)\"\n      :class=\"[menu.key === activeMenu ? 'turquoise primaryDark--text':'']\"\n    >\n      <v-list-tile-content>\n        <v-list-tile-title>{{$t(lblSetting.serviceBookSidebar[menu.key])}} {{getTotal(menu.totalKey)}}</v-list-tile-title>\n      </v-list-tile-content>\n    </v-list-tile>\n  </v-list>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/containers/service-book/components/sidebar/template.html
// module id = uZ4g
// module chunks = 0